import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtrarIndicadores'
})
export class FiltrarIndicadoresPipe implements PipeTransform {

  transform(value: Array<any>, curso: number, asignatura:number, area:number, filtrar:string): Array<any> {
    let newArr = []

    newArr = value.filter(
      d => (d.IdCurso == curso || curso == 0) && (d.IdAsignatura == asignatura || asignatura == 0) &&
      (d.IdArea == area || area == 0) && 
      String(d.IndicadorLogroDescripcion).toLowerCase().indexOf(filtrar.toLowerCase())>-1
    )

    return newArr;
  }

}
